"use client";
import { createContext, useContext, type ReactNode } from "react";

export type ErrorConfig = {
  title: string | null;
  content: string | null;
};

const ErrorConfigContext = createContext<ErrorConfig>({
  title: null,
  content: null,
});

export function ErrorConfigProvider({
  config,
  children,
}: {
  config: ErrorConfig;
  children: ReactNode;
}) {
  return (
    <ErrorConfigContext.Provider value={config}>
      {children}
    </ErrorConfigContext.Provider>
  );
}

export function useErrorConfig() {
  return useContext(ErrorConfigContext);
}
